// Salin teks ke clipboard. Memakai API modern bila tersedia (hanya di https/localhost); bila tidak (browser lama, iframe,
// izin ditolak) jatuh ke cara lama lewat textarea tersembunyi. Mengembalikan true bila berhasil.
export const salinTeks = async (teks) => {
  const nilai = String(teks == null ? '' : teks);
  try {
    if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(nilai);
      return true;
    }
  } catch (e) { /* lanjut ke cara lama */ }
  try {
    const area = document.createElement('textarea');
    area.value = nilai;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(area);
    return !!ok;
  } catch (e) {
    return false;
  }
};
